'use strict';


/**
 * PopUp
 * */


const PopUpHTML = `
<div id="popup-wrapper"><i id="popup-close" class="x"></i><div id="popup-content-wrapper"></div></div>
`;

class PopupWindowCls {
	constructor() {

		let docFragment = document.createDocumentFragment();

		
		//это черный фон
		this.ScrennWrapper = document.createElement('div');
		this.ScrennWrapper.setAttribute('id', 'screen-wrapper');
		docFragment.appendChild(this.ScrennWrapper);

		//это контейнер
		this.PopupScreenWrapper = document.createElement('div');
		this.PopupScreenWrapper.setAttribute('id', 'popup-screen-wrapper');
		docFragment.appendChild(this.PopupScreenWrapper);

		document.body.appendChild(docFragment);


		this.PopupScreenWrapper.innerHTML = PopUpHTML;

		this.contentWrapper = this.PopupScreenWrapper.querySelector('#popup-content-wrapper');

		this.close = this.PopupScreenWrapper.querySelector('#popup-close');


		this.close.addEventListener('click', (e) => {
			this.hide();
		})

	}

	show() {
		this.ScrennWrapper.classList.add('open');
		this.PopupScreenWrapper.classList.add('open');
		this.status = 'popup-wakeup';

	}

	empty() {
		this.contentWrapper.replaceChildren();
	}

	hide() {
		this.ScrennWrapper.classList.remove('open');
		this.PopupScreenWrapper.classList.remove('open');
		this.status = 'popup-sleep';
	}

	set status(value) {
		this.contentWrapper.className  = value;
		//this.g.id = value;
	}	

	get status() {
		return this.contentWrapper.className;
	}

	getContentWrapper() {
		return this.contentWrapper;
	}
}

export let PopupWindow = new PopupWindowCls();
